import React from "react";
import { ArrowUpRight } from "lucide-react";
import { SocialLink } from "../sample.data";
import { getVisibleSortedItems } from "../utils";

interface SocialLinksProps {
  socials: SocialLink[];
}

export const SocialLinks: React.FC<SocialLinksProps> = ({ socials }) => {
  const visibleSocials = getVisibleSortedItems(socials);

  if (visibleSocials.length === 0) return null;

  return (
    <div className="mt-6 flex flex-wrap gap-3">
      {visibleSocials.map((social) => (
        <a
          key={social.id}
          href={social.href}
          target="_blank"
          rel="noreferrer"
          className="pill-apple px-4 py-2 text-sm"
        >
          <social.icon className="h-4 w-4" /> {social.label}
          <ArrowUpRight className="h-4 w-4" />
        </a>
      ))}
    </div>
  );
};
